import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';

export function OAuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Connecting to Airbnb...');

  useEffect(() => {
    const code = searchParams.get('code');

    if (!code) {
      setStatus('error');
      setMessage('No authorization code received.');
      return;
    }

    // The backend handles the token exchange at the redirect URI.
    // Show success and redirect back to Channel Manager.
    setStatus('success');
    setMessage('Successfully connected to Airbnb!');
    const timer = setTimeout(() => navigate('/channel-manager'), 2000);
    return () => clearTimeout(timer);
  }, [searchParams, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4">
      {status === 'loading' && (
        <>
          <Loader2 size={32} className="animate-spin text-primary-600" aria-hidden="true" />
          <p className="text-sm text-gray-600">{message}</p>
        </>
      )}
      {status === 'success' && (
        <>
          <CheckCircle2 size={32} className="text-green-600" aria-hidden="true" />
          <p className="text-sm text-green-700">{message}</p>
          <p className="text-xs text-gray-400">Redirecting...</p>
        </>
      )}
      {status === 'error' && (
        <>
          <XCircle size={32} className="text-red-600" aria-hidden="true" />
          <p className="text-sm text-red-700">{message}</p>
          <button
            type="button"
            onClick={() => navigate('/channel-manager')}
            className="mt-2 text-sm text-primary-600 hover:underline"
          >
            Back to Channel Manager
          </button>
        </>
      )}
    </div>
  );
}
